import { render } from "./RecentProjects.vue?vue&type=template&id=0ba9c46a"
import script from "./RecentProjects.vue?vue&type=script&lang=js"
export * from "./RecentProjects.vue?vue&type=script&lang=js"

import "./RecentProjects.vue?vue&type=style&index=0&id=0ba9c46a&lang=scss"
script.render = render

export default script